/**
 * Records eyeglass PDP browsing taste (shape + color) for personalized cart recs.
 */
(function () {
  var STORAGE_KEY = 'ciwBrowseTaste';
  var MAX_ENTRIES = 20;

  function colorFamily(color) {
    var c = String(color || '').toLowerCase();
    if (!c) return 'other';
    if (/black|onyx|noir|ebony/.test(c)) return 'black';
    if (/tortoise|havana|horn|leopard|spot|demi/.test(c)) return 'tortoise';
    if (/gold|champagne|copper|bronze|rose gold/.test(c)) return 'gold';
    if (/silver|gunmetal|steel|chrome|nickel|metallic|titanium/.test(c)) return 'silver';
    if (/clear|crystal|transparent|ice|polished transparent/.test(c)) return 'clear';
    if (/blue|navy|azure|sapphire|cobalt/.test(c)) return 'blue';
    if (/brown|coffee|caramel|wood|amber|mocha|honey|tan/.test(c)) return 'brown';
    if (/green|olive|emerald|mint/.test(c)) return 'green';
    if (/pink|rose|mauve|coral|fuchsia/.test(c)) return 'pink';
    if (/red|burgundy|wine|maroon|cranberry|cherry/.test(c)) return 'red';
    if (/grey|gray|smoke|charcoal|slate|graphite/.test(c)) return 'grey';
    if (/purple|violet|plum|lilac|lavender/.test(c)) return 'purple';
    if (/white|pearl|ivory|cream|beige|nude|sand|bone/.test(c)) return 'neutral';
    return 'other';
  }

  function readTaste() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeTaste(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ENTRIES)));
    } catch (e) {}
  }

  function normalizeEntry(entry) {
    if (!entry || !entry.handle) return null;
    entry.handle = String(entry.handle).trim();
    if (!/^[a-z0-9-]+$/.test(entry.handle)) return null;
    entry.shape = entry.shape && entry.shape !== '--' ? String(entry.shape).trim() : '';
    entry.color = entry.color ? String(entry.color).trim() : '';
    entry.colorFamily = entry.colorFamily || colorFamily(entry.color);
    entry.vendor = entry.vendor ? String(entry.vendor).trim() : '';
    entry.isDesigner = !!entry.isDesigner;
    entry.isUnisex = !!entry.isUnisex;
    entry.viewedAt = entry.viewedAt || Date.now();
    return entry;
  }

  function recordTaste(entry) {
    var normalized = normalizeEntry(entry);
    if (!normalized) return;

    var list = readTaste().filter(function (item) {
      return item.handle !== normalized.handle;
    });
    list.unshift(normalized);
    writeTaste(list);
  }

  function updateTasteColor(handle, color, shape) {
    if (!handle || !color) return;
    var list = readTaste();
    var found = false;

    list = list.map(function (item) {
      if (item.handle !== handle) return item;
      found = true;
      return normalizeEntry({
        handle: item.handle,
        shape: shape || item.shape,
        color: color,
        colorFamily: colorFamily(color),
        vendor: item.vendor,
        isDesigner: item.isDesigner,
        isUnisex: item.isUnisex,
        viewedAt: Date.now()
      });
    });

    if (!found) return;
    writeTaste(list);
  }

  function getVariantColor(productVariants, variantId) {
    if (!productVariants || !variantId) return '';
    var data = productVariants[String(variantId)];
    return data && data.color ? data.color : '';
  }

  function getVariantShape(productVariants, variantId) {
    if (!productVariants || !variantId) return '';
    var data = productVariants[String(variantId)];
    return data && data.shape && data.shape !== '--' ? data.shape : '';
  }

  function initFromBootstrap() {
    var el = document.getElementById('ciw-browse-taste-bootstrap');
    if (!el) return;

    var bootstrap;
    try {
      bootstrap = JSON.parse(el.textContent || '{}');
    } catch (e) {
      return;
    }

    if (!bootstrap.handle) return;

    var variants = bootstrap.variants || {};
    var variantId = bootstrap.variantId;
    var color = getVariantColor(variants, variantId) || bootstrap.color || '';
    var shape = getVariantShape(variants, variantId) || bootstrap.shape || '';

    recordTaste({
      handle: bootstrap.handle,
      shape: shape,
      color: color,
      vendor: bootstrap.vendor,
      isDesigner: bootstrap.isDesigner,
      isUnisex: bootstrap.isUnisex,
      viewedAt: Date.now()
    });

    document.addEventListener('variant:changed', function (event) {
      var detail = event && event.detail;
      var nextVariantId = detail && (detail.variantId || (detail.variant && detail.variant.id));
      if (!nextVariantId) return;

      var nextColor = getVariantColor(variants, nextVariantId);
      var nextShape = getVariantShape(variants, nextVariantId) || shape;
      if (!nextColor) return;
      updateTasteColor(bootstrap.handle, nextColor, nextShape);
    });
  }

  window.CIW_BROWSE_TASTE = {
    colorFamily: colorFamily,
    read: readTaste,
    record: recordTaste,
    updateColor: updateTasteColor
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromBootstrap);
  } else {
    initFromBootstrap();
  }
})();
